import './reset.css';
import './App.css';
import Router from './components/Router';

function App() {
	return (
		<div className="container">
			<Router />
		</div>
	);
}

export default App;
